<template>
  <header class="game-header">
    <div class="game-header__title">
      <h1>Horse Racing</h1>
    </div>
    <div class="game-header__actions">
      <button 
        class="game-header__btn game-header__btn--generate"
        @click="handleGenerateProgram"
        :disabled="isRaceRunning"
      >
        Generate Program
      </button>
      <button 
        class="game-header__btn game-header__btn--start"
        @click="handleStartPause"
        :disabled="!isProgramReady || isAllRoundsCompleted"
      >
        {{ startButtonText }}
      </button>
    </div>
  </header>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { RACE_STATUS } from '@/constants'

export default {
  name: 'GameHeader',
  setup() {
    const store = useStore()
    
    const raceStatus = computed(() => store.getters['race/raceStatus'])
    const isProgramReady = computed(() => store.getters['race/isProgramReady'])
    const isRaceRunning = computed(() => store.getters['race/isRaceRunning'])
    const isAllRoundsCompleted = computed(() => store.getters['race/isAllRoundsCompleted'])
    
    const startButtonText = computed(() => {
      if (raceStatus.value === RACE_STATUS.RUNNING) return 'Pause'
      if (raceStatus.value === RACE_STATUS.PAUSED) return 'Resume'
      if (isAllRoundsCompleted.value) return 'Finished'
      return 'Start / Pause'
    })
    
    function handleGenerateProgram() {
      if (!store.getters['horses/isHorsesGenerated']) {
        store.dispatch('horses/generateHorses')
      }
      store.dispatch('race/resetRace')
      store.dispatch('race/generateProgram')
    }
    
    function handleStartPause() {
      store.dispatch('race/toggleRace')
    }
    
    return {
      isProgramReady,
      isRaceRunning,
      isAllRoundsCompleted,
      startButtonText,
      handleGenerateProgram,
      handleStartPause
    }
  }
}
</script>

<style scoped>
.game-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-bg-card);
  padding: var(--space-4) var(--space-6);
  height: var(--header-height);
  border-bottom: 1px solid var(--color-border);
  box-shadow: var(--shadow-sm);
  flex-shrink: 0;
}

.game-header__title h1 {
  margin: 0;
  color: var(--color-text);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.025em;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.game-header__title h1::before {
  content: '🏇';
  font-size: 24px;
}

.game-header__actions {
  display: flex;
  gap: var(--space-3);
}

.game-header__btn {
  padding: var(--space-3) var(--space-5);
  border: none;
  border-radius: var(--radius);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  /* text-transform: uppercase; */
  letter-spacing: 0.025em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-width: 160px;
  box-shadow: var(--shadow-sm);
}

.game-header__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none;
}

.game-header__btn--generate {
  background: linear-gradient(135deg, var(--color-warning) 0%, var(--color-warning-hover) 100%);
  color: white;
}

.game-header__btn--generate:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  filter: brightness(1.05);
}

.game-header__btn--generate:active:not(:disabled) {
  transform: translateY(0);
}

.game-header__btn--start {
  background: linear-gradient(135deg, var(--color-secondary) 0%, var(--color-secondary-hover) 100%);
  color: white;
}

.game-header__btn--start:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
  filter: brightness(1.05);
}

.game-header__btn--start:active:not(:disabled) {
  transform: translateY(0);
}
</style>
